import pagesService from '@/services/pages'
import postsService from '@/services/posts'
import termsService from '@/services/terms'
import prevnextService from '@/services/prev-next'
import menusService from '@/services/menus'
import optionsService from '@/services/options'
import customfieldsService from '@/services/customfields'
import tweetsService from '@/services/tweets'
import donationService from '@/services/donation'
import mailchimpService from '@/services/mailchimp'
import brevoService from '@/services/brevo'

export const pages = pagesService
export const posts = postsService
export const terms = prevnextService
export const prevnext = menusService
export const menus = menusService
export const options = optionsService
export const customfields = customfieldsService
export const tweets = tweetsService
export const donation = donationService
export const mailchimp = mailchimpService
export const brevo = brevoService

let fetchUrl
let fetchOptions = {}
if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_DEV_DIST_URL) {
  // Sanitize provided base
  fetchUrl = process.env.VUE_APP_DEV_DIST_URL
    .replace(/^https\/\//i, 'https://')
    .replace(/^http\/\//i, 'http://')
    .replace(/\/$/, '')
  if (process.env.VUE_APP_DEV_DIST_AUTH) {
    fetchOptions = {
      headers: {
        'Authorization': `Basic ${btoa(process.env.VUE_APP_DEV_DIST_AUTH)}`
      }
    }
  }
} else {
  // Include protocol + host + port
  fetchUrl = window.location.origin.replace(/\/$/, '')
}

export const fetch = function (url, options = {}) {
  options = Object.assign(options, fetchOptions)
  // Normalize malformed schemes like 'https//' or 'http//' (missing colon)
  if (/^https\/\//i.test(url)) url = url.replace(/^https\/\//i, 'https://')
  if (/^http\/\//i.test(url)) url = url.replace(/^http\/\//i, 'http://')
  // If url is already absolute, do not prefix
  const isAbsolute = /^https?:\/\//i.test(url)
  const finalUrl = isAbsolute ? url : new URL(url, `${fetchUrl}/`).toString()
  return window.fetch(finalUrl, options)
}

export default {
  pages: pagesService,
  posts: postsService,
  terms: termsService,
  prevnext: prevnextService,
  menus: menusService,
  options: optionsService,
  customfields: customfieldsService,
  tweets: tweetsService,
  donation: donationService,
  mailchimp: mailchimpService,
  brevo: brevoService
}
